var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-layout',{attrs:{"isChild":true},scopedSlots:_vm._u([{key:"table",fn:function(){return [_c('v-server-table',{ref:"file-errors",attrs:{"columns":_vm.columns,"options":_vm.options},on:{"loaded":_vm.onLoaded}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }